import React from "react";
import { Table, Toast } from "react-bootstrap";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { selectIsMetric } from "../../store/slices/settingsSlice";
import ConvertToString from "../../components/Converter";
import { ImperialUnits, MetricUnits } from "../../components/Math/Units/AllUnits";
import {
  CLAY_OR_ROCK,
  FOR_INS_WITH_EXT_JETTING,
  MEDIUM_AND_CORASE_GRAVEL,
  SAND_AND_SANDY_GRAVEL,
} from "../../constants";
import ConvertMeasurement from "../../components/Math/Conversion/ConvertMeasurement";

function WideningInfo({ show, setShow }) {
  const { t } = useTranslation("translation");
  const nodeRef = React.useRef(null);
  const isMetric = useSelector(selectIsMetric);
  const toUnit = isMetric ? MetricUnits.Millimetre : ImperialUnits.Inch;
  const showUnit = isMetric ? "mm" : "in";

  return (
    <Draggable nodeRef={nodeRef} defaultPosition={{ x: 65, y: -225 }}>
      <Toast
        ref={nodeRef}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
      >
        <Toast.Header>
          <strong className="mx-auto">{t("holewidening.title")}</strong>
        </Toast.Header>
        <Toast.Body>
          <Table borderless hover responsive size="sm" style={{ tableLayout: "auto" }}>
            <thead>
              <tr className="table-active">
                <CenteredHeadline>
                  {`${t("aashto.ausser.Widening")} [ ${showUnit} ]`}
                </CenteredHeadline>
                <CenteredHeadline>{t("holewidening.header")}</CenteredHeadline>
              </tr>
            </thead>
            <tbody>
              <tr>
                <CenteredCell>
                  {ConvertToString(
                    ConvertMeasurement({
                      userInput: MEDIUM_AND_CORASE_GRAVEL,
                      from: ImperialUnits.Inch,
                      to: toUnit,
                    })
                  )}
                </CenteredCell>
                <CenteredCell>{t("holewidening.value_3")}</CenteredCell>
              </tr>
              <tr>
                <CenteredCell>
                  {ConvertToString(
                    ConvertMeasurement({
                      userInput: SAND_AND_SANDY_GRAVEL,
                      from: ImperialUnits.Inch,
                      to: toUnit,
                    })
                  )}
                </CenteredCell>
                <CenteredCell>{t("holewidening.value_2")}</CenteredCell>
              </tr>
              <tr>
                <CenteredCell>
                  {ConvertToString(
                    ConvertMeasurement({
                      userInput: FOR_INS_WITH_EXT_JETTING,
                      from: ImperialUnits.Inch,
                      to: toUnit,
                    })
                  )}
                </CenteredCell>
                <CenteredCell>{t("holewidening.value_1")}</CenteredCell>
              </tr>
              <tr>
                <CenteredCell>
                  {ConvertToString(
                    ConvertMeasurement({
                      userInput: CLAY_OR_ROCK,
                      from: ImperialUnits.Inch,
                      to: toUnit,
                    })
                  )}
                </CenteredCell>
                <CenteredCell>{t("holewidening.value_0")}</CenteredCell>
              </tr>
            </tbody>
          </Table>
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}

export default WideningInfo;

const CenteredHeadline = styled.th`
  && {
    text-align: center;
    vertical-align: middle;
  }
`;

const CenteredCell = styled.td`
  && {
    text-align: left;
    vertical-align: middle;
  }
`;
